// src/Science/Grade12/Grade12ScienceMenu.js
import React from "react";
import { useNavigate } from "react-router-dom";

export default function Grade12ScienceMenu() {
  const navigate = useNavigate();

  return (
    <div className="grade-selector-menu">
      <h2>Grade 12 Science</h2>
      <button className="button1" onClick={() => navigate("biology")}>Biology</button>
      <button className="button1" onClick={() => navigate("chemistry")}>Chemistry</button>
      <button className="button1" onClick={() => navigate("physics")}>Physics</button>
    </div>
  );
}
